//This will be the dropdown item you see on the schedule page.  You can choose from
//either a league or a team to view a desired schedule
import React, { useState, useEffect } from 'react'
import Card from './Card'
import { useNavigate, useParams } from 'react-router-dom'

const FilterByTeam = (props) => {
	const [isLoading, setIsLoading] = useState(false)
	const [loadedTeams, setLoadedTeams] = useState()
	const [leagueName, setLeagueName] = useState()
	const [session, setSession] = useState()
	const [year, setYear] = useState()
	const [error, setError] = useState()
	const [loadedDivisions, setLoadedDivisions] = useState()

	const leagueId = useParams().leagueId || props.leagueId
	//const leagueId = props.leagueId

	let selectedTeam, selectedDivision

	console.log('inside FilterByTeam for leagueId: ' + leagueId)
	//
	//
	//
	//Make backend call to getTeamsInLeagueByLeagueId
	useEffect(() => {
		const getTeamsInLeague = async () => {
			/* console.log(
				'inside FilterByTeam --> making backend call to getTeamsInLeagueByLeagueId'
			) */
			setIsLoading(true)
			try {
				const response = await fetch(
					`${process.env.REACT_APP_BACKEND_URL}/admin/allTeams/${leagueId}`
					//process.env.REACT_APP_BACKEND_URL + '/league/allCurrentTeams'
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				//console.log('listOfTeams: ' + JSON.stringify(responseData))
				/* console.log(
					'setLoadedTeams: ' + JSON.stringify(responseData.listOfTeams)
				) */

				setLoadedTeams(responseData.listOfTeams)
				setLeagueName(responseData.leagueName)
				setSession(responseData.session)
				setYear(responseData.year)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		getTeamsInLeague()
	}, [setLoadedTeams])
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//  Lets try to add division in here too:
	//Call backend to get all the current DIVISIONS for our dropdown
	useEffect(() => {
		const sendRequest4 = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + '/admin/divisions'
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error('error message: ' + responseData.message)
				}

				setLoadedDivisions(responseData.allDivisions)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest4()
	}, [setLoadedDivisions])

	let divisionsArray
	divisionsArray = []

	if (loadedDivisions && !isLoading) {
		//divisionsArray = []
		loadedDivisions.forEach((division) => {
			if (division.leagueId === leagueId) {
				divisionsArray.push(division)
			}
		})
	}
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	let teamArray

	//loadedTeams && console.log('loadedTeams: ' + JSON.stringify(loadedTeams))

	if (loadedTeams && !isLoading) {
		teamArray = []
		loadedTeams.forEach((team) => {
			teamArray.push(team)
		})
		teamArray.sort((a, b) => a.divisionName.localeCompare(b.divisionName))
	}

	//console.log('teamArray: ' + JSON.stringify(teamArray))

	let navigate = useNavigate()

	//For handling a search by TEAM request
	const handleChange2 = (e) => {
		e.preventDefault()
		const selectedValue = e.target.value
		//console.log('selectedValue: ' + selectedValue)
		selectedTeam = teamArray[selectedValue]
		console.log('selectedTeam: ' + JSON.stringify(selectedTeam))
		const teamId = selectedTeam._id
		const teamName = selectedTeam.teamName
		/* < - - navigate to TeamSchedule.js - - >*/
		navigate(`/league/schedule/${leagueName}/${teamId}/${year}/${teamName}`)
	}

	//For handling a search by Division request
	const handleChange4 = (e) => {
		e.preventDefault()
		const selectedValue = e.target.value
		console.log('selectedValue: ' + selectedValue)
		selectedDivision = divisionsArray[selectedValue]
		console.log('selectedDivision: ' + selectedDivision)
		const divisionId = selectedDivision._id
		console.log('divisionId: ' + divisionId)
		navigate(`/league/division/${divisionId}/schedule`) //< - - - should go to DivisionSchedule
	}

	return (
		<React.Fragment>
			<div className='searchbyleagueorvenue'>
				<div className='row'>
					<div className='LTVinstructions'>Filter by Team or Division: </div>
				</div>
				{!isLoading && loadedTeams && (
					<div className='row'>
						<div className='col'></div>
						<div className='col-sm'>
							<form className='dropdownForm' style={{ textAlign: 'center' }}>
								<select className='scheduleselector' onChange={handleChange2}>
									<option defaultValue>Team....</option>
									{teamArray.map((team, i) => (
										<option value={i} key={i}>
											{team.divisionName + ' >>> ' + team.teamName}
										</option>
									))}
								</select>
							</form>
						</div>
						<div className='col'></div>
					</div>
				)}
				{!isLoading &&
					loadedDivisions &&
					divisionsArray &&
					divisionsArray.length > 0 && (
						<div className='row'>
							<div className='col'></div>
							<div className='col-sm'>
								{/* <form className='form-control-lg'> */}
								<form className='dropdownForm' style={{ textAlign: 'center' }}>
									<select
										className='scheduleselector'
										// className='my-1 mr-sm-2 scheduleselector'
										onChange={handleChange4}
									>
										<option defaultValue>Division....</option>
										{divisionsArray.map((division, i) => (
											<option value={i} key={i}>
												{/* {team.toUpperCase()} */}
												{division.divisionName}
											</option>
										))}
									</select>
								</form>
							</div>
							<div className='col'></div>
						</div>
					)}
			</div>
		</React.Fragment>
	)
}

export default FilterByTeam
